import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SourceEditFormType } from './source-edit-form-type';
import { TranslateModule } from '@ngx-translate/core';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';

@Component({
    selector: 'app-source-edit-form',
    templateUrl: './source-edit-form.component.html',
    styleUrls: ['./source-edit-form.component.scss'],
    imports: [ReactiveFormsModule, FormsModule, TranslateModule, AppErrorMessagesComponent]
})
export class SourceEditFormComponent {

  @Input()
  public sourceEditForm: FormGroup<SourceEditFormType>;

  constructor(
  ) { }
}
